<script setup lang="ts">
import { computed, ref } from "vue";

interface Props {
  text: string;
  closedText?: string;
  openedText?: string;
  initialllyVisible?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  initialllyVisible: false,
  openedText: "Ocultar" ,
  closedText: "Ver contenido",
});

const isVisible = ref(props.initialllyVisible);

const content = computed(() => {
  return isVisible.value ? props.text : props.closedText;
});
</script>

<template>
  <div>
    <span :class="['text-justify text-base text-black', !isVisible ? 'cursor-pointer font-semibold underline' : '']" @click="!isVisible ? isVisible = true : null">{{ content }}</span>
    
    <span v-if="isVisible" class="text-black underline cursor-pointer text-base font-semibold ml-2" @click="isVisible = !isVisible">{{ openedText }}</span>
  </div>
</template>

<style scoped></style>
